import { useContext } from 'react';

import styles from './modal_base.module.scss';

import { AppContext } from '../../../router/approuter';

const ModalBase = () => {
    const appContext = useContext(AppContext)

    const getStopClass = () => {
        return appContext.modalFull && appContext.isDesktopOrLaptop ? styles.stop_propagation_scroll : styles.stop_propagation;
    }

    const handleClickOut = () => {
        appContext.setModalFull(false);
        appContext.setModalFlag(!appContext.modalFlag);
    }

    return (
        // <div className={ styles.modal_base } onClick={() => appContext.setModalFlag(false)}>
        <div className={ `${styles.modal_base} ${ appContext.modalFull ? styles.full : '' }` } onClick={ handleClickOut }>
            <div className={ getStopClass() } onClick={(event) => event.stopPropagation() }>
                {
                    appContext.modalContent
                }
            </div>
        </div>
    )
}
export default ModalBase